import React from 'react';
import { motion } from 'framer-motion';
import WebsitePrev from '../../pages/Onboarding/common/websitePrev';
import slackIcon from '../../assets/slack-icon.png';

interface PreviewCardProps {
  variant?: 'preview' | 'slack';
  showRole?: boolean;
  role?: string;
  companyName?: string;
}

const PreviewCard: React.FC<PreviewCardProps> = ({ 
  variant = 'preview',
  showRole = false,
  role,
  companyName = 'Workspace title'
}) => {
  // preview animation - Slide and fade in from right
  const previewVariants = {
    initial: { x: 50, opacity: 0 },
    animate: { 
      x: 0, 
      opacity: 1,
      transition: { 
        duration: 0.6,
        ease: [0.6, -0.05, 0.01, 0.99]
      }
    }
  };

  // Slack specific animations
  const slackButtonVariants = {
    initial: { y: -20, opacity: 0 },
    animate: { 
      y: 0, 
      opacity: 1,
      transition: { duration: 0.4, ease: "easeOut" }
    },
    hover: {
      y: -2,
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      transition: { duration: 0.2 }
    }
  };

  const arrowVariants = {
    initial: { height: 0, opacity: 0 },
    animate: { 
      height: "60px",
      opacity: 1,
      transition: { 
        height: { duration: 0.4, delay: 0.3 },
        opacity: { duration: 0.3, delay: 0.3 }
      }
    }
  };

  const previewImageVariants = {
    initial: { scale: 0.95, opacity: 0, y: 20 },
    animate: { 
      scale: 1,
      opacity: 1,
      y: 0,
      transition: { 
        duration: 0.5,
        delay: 0.6,
        ease: "easeOut"
      }
    },
    hover: {
      scale: 1.02,
      transition: { duration: 0.3 }
    }
  };

  if (variant === 'slack') {
    return (
      <div className="flex flex-col items-start w-fit h-full bg-[#FAFAFA] relative pt-[84px]">
        <motion.div 
          className="w-fit flex justify-center ml-[176px]"
          variants={slackButtonVariants}
          initial="initial"
          animate="animate"
        >
          <div className="w-[191px] h-[30px] bg-[#FFFFFF] rounded-[8px] flex items-center justify-center gap-2 border border-[#EEEEEE] shadow-[0_2px_8px_rgba(0,0,0,0.08)]">
            <img src={slackIcon} alt="slack icon" className="w-[16px] h-[16px]" />
            <p className="text-[#222222] text-[12px] font-normal">Slack</p>
          </div>
        </motion.div>
        
        <motion.div 
          className="w-fit flex justify-center ml-[271px]"
          variants={arrowVariants}
          initial="initial"
          animate="animate"
        >
          <div className="flex flex-col items-center">
            <div className="h-[70px] border-l border-dashed border-[#222222]"></div>
            <div className="w-0 h-0 
              border-l-[4px] border-l-transparent 
              border-r-[4px] border-r-transparent 
              border-t-[6px] border-t-[#222222] 
              -mt-[2px]"
            ></div>
          </div>
        </motion.div>
        
        <motion.div 
          className="w-full flex justify-center"
          variants={previewImageVariants}
          initial="initial"
          animate="animate"
          whileHover="hover"
        >
          <WebsitePrev 
            showRole={showRole} 
            role={role} 
            companyName={companyName}
          />
        </motion.div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-start justify-center h-full bg-[#FAFAFA]">
      <motion.div
        variants={previewVariants}
        initial="initial"
        animate="animate"
        whileHover="hover"
        className="w-full"
      >
        <WebsitePrev 
          showRole={showRole} 
          role={role} 
          companyName={companyName}
        />
      </motion.div>
    </div>
  );
};

export default PreviewCard; 